import React, { FC } from 'react'
import {
    StyledArrow,
    StyledButton,
    StyledButtonInnerContainer,
    StyledSpinner,
} from './LiveEventJumpToTopButton.styled'

export interface JumptToTopButtonProps {
    onClick: () => void
    inViewport: boolean
    isLoading: boolean
    newPostCount: number
}

export const JumpToTopButton: FC<JumptToTopButtonProps> = ({
    onClick,
    inViewport,
    isLoading,
    newPostCount,
}) => {
    const showButton = inViewport || newPostCount > 0

    const buttonLabel = () => {
        switch (newPostCount) {
            case 0:
                return 'Jump to top'
            case 1:
                return '1 New Update'
            default:
                return `${newPostCount} New Updates`
        }
    }

    const Icon: FC = () =>
        newPostCount > 0 ? (
            <StyledSpinner rotate={isLoading} />
        ) : (
            <StyledArrow />
        )

    const handleOnClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
        e.currentTarget.blur()
        onClick()
    }

    return (
        <StyledButton onClick={handleOnClick} show={showButton}>
            <StyledButtonInnerContainer>
                <Icon />
                <span>{buttonLabel()}</span>
            </StyledButtonInnerContainer>
        </StyledButton>
    )
}
